import { createSlice } from "@reduxjs/toolkit";

const sideSlice = createSlice({
  name: "accountbar",
  initialState: {
    toggle: false,
  },
  reducers: {
    toggleAccountBar: (state) => {
      state.toggle = !state.toggle;
    },
    logoutAccountBar: (state) => {
      state.toggle = false;
    },
  },
});

export const { toggleAccountBar, logoutAccountBar } = sideSlice.actions;

export default sideSlice.reducer;
